import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { cssProperties } from "../utils/commonCssProperties";
import Header from "./header";
import Sidebar from "./SideBar";

const ROUTES_WITHOUT_SIDEBAR = ["download-admit-card", "download-score-card"];
// These pages draw their own header.
const ROUTES_WITHOUT_HEADER = ["download-admit-card"];

const Layout = ({ children }) => {
  const { showSidebar } = useSelector((state) => state.commonReducer);
  const location = useLocation();

  const hideSidebar = ROUTES_WITHOUT_SIDEBAR.some((route) =>
    location.pathname.includes(route)
  );
  const hideHeader = ROUTES_WITHOUT_HEADER.some((route) =>
    location.pathname.includes(route)
  );

  return (
    <>
      <Box
        sx={{
          width: `calc(100% - ${showSidebar} ? ${cssProperties?.drawerWidth}px) : "0px" `,
          ml: hideSidebar ? 0 : `${cssProperties?.drawerWidth}px`,
          height: `calc(100% - ${cssProperties?.headerHight}px)`,
          mt: hideHeader ? 0 : `${cssProperties?.headerHight}px`,
          padding: "0 24px 15px 24px"
        }}
      >
        {!hideHeader && <Header />}
        {!hideSidebar && <Sidebar />}
        {children}
      </Box>
    </>
  );
};

export default Layout;
